import { GetNavigator } from "@pdfking/capability"
import { NullQ } from "@pdfking/structs"

async function hasWebGPU() {
  const gpu = GetNavigator()?.gpu
  if (!gpu) return false
  try {
    const adapter = await gpu.requestAdapter()
    return !NullQ(adapter)
  } catch {
    return false
  }
}

export async function GetThree(use_regular: boolean = true) {
  const settings = { alpha: true, antialias: true }

  if (use_regular || !(await hasWebGPU())) {
    console.info("[GetThree] Using WebGL renderer")
    const three = await import("./Three")
    const renderer = new three.ThreeRenderer(settings)
    return { enum: "webgl" as const, renderer, three }
  }

  console.info("[GetThree] Using WebGPU renderer")
  const three = await import("./ThreeWebGPU")
  const renderer = new three.ThreeRenderer(settings)
  await renderer.init()
  return { enum: "webgpu" as const, renderer, three }
}
